import { useState } from "react";
import { Route, Routes } from "react-router-dom";

import { ConfigProvider, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import MobileLayout from "@/layout/MobileLayout";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import MyTemplates from "@/page/MyTemplates";
import HomePage from "@/page/HomePage";
import Profile from "@/page/Profile";
import VerifyPage from "@/page/VerifyPage";
import LoginPage from "./page/Login";
import NotFound from "./page/NotFound";
import ChipScanError from "./page/ChipScanError";
import ChipNotConfigured from "./page/ChipNotConfigured";

// Form Templates
import TemplateView from "./page/TemplateView";
import PublicView from "./page/PublicView";

function App() {
  const [isLoading] = useState(false);

  return (
    <ConfigProvider>
      <GoogleAnalytics />
      {isLoading ? (
        <div className="loading-overlay flex flex-col items-center justify-center gap-2">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
          <div className="loading-text">Đang tải</div>
        </div>
      ) : (
        <Routes>
          <Route element={<MobileLayout />}>
            <Route path="/" element={<MyTemplates />} />
            <Route path="/create" element={<HomePage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/scan-error" element={<ChipScanError />} />
            <Route path="/not-configured" element={<ChipNotConfigured />} />

            {/* Templates */}
            <Route path="/scan" element={<TemplateView />} />
            <Route path="/view" element={<PublicView />} />
          </Route>
        </Routes>
      )}
    </ConfigProvider>
  );
}

export default App;
